import {
  breadcrumb_styles_default
} from "./chunk.NFQPW7ZY.js";
import {
  smUp,
  xs
} from "./chunk.QLZDQDDJ.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/breadcrumb/breadcrumb.styles.ts
var breadcrumb_styles_default2 = r` ${breadcrumb_styles_default} .breadcrumb__icon-button::part(base) { color: var(--sl-color-primary-700); padding-right: var(--sl-spacing-3x-small); } .breadcrumb__icon-button { display: inline-flex; } ${xs(r` slot { display: none; } `)} ${smUp(r` .breadcrumb__icon-button { display: none; } `)} `;

export {
  breadcrumb_styles_default2 as breadcrumb_styles_default
};
